import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

import { CrossIcon, PlusSignIcon } from "../../assets/icons";
import { PlanDetailPlanOptionResponseMealTypeListEnum } from "../../openapi/client";
import { displayFormat, checkIf } from "../../utils";
import DiscountCrud from "../DiscountCrud";
import Transition from "../Transition";
import UserDetail from "../../pages/UserDetail";

interface IProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  userId: string;
  date: string;
}

export default function ReviewDialog(props: IProps) {
  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      onClose={props.onClose}
      aria-describedby="alert-dialog-slide-description"
      sx={{
        "& > .MuiDialog-container > .MuiPaper-root": {
          borderRadius: "16px",
          boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.15)",
          padding: "24px",
          width: "90%",
          maxWidth: "90%",
          height: "100%",
        },
        "& .MuiDialogTitle-root": {
          padding: "0 16px 16px 0",
        },
        "& .MuiDialogContent-root,& .MuiDialogActions-root": {
          padding: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "text.dark",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "20px",
        }}
      >
        {props.title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "text.fontLight2",
        }}
      >
        <CrossIcon />
      </IconButton>
      <DialogContent>
        <UserDetail userId={props.userId} date={props.date} activeTab={2} />
      </DialogContent>
    </Dialog>
  );
}
